import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import Billing from 'component/view/Settings/Billing';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/billing/')({
  beforeLoad: requireOperation({
    options: () => RocketAPI.account.getFindAccountHostingPlanQueryOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: Billing,
});
